import axios from 'axios'
import router from '../router'

// let localApi = 'https://www.mimoprint.vip/'
// beta
// let localApi = 'http://192.168.1.198:9003/'
// let localApi = 'https://tbbeta.mimoprint.com'
// let localApi = 'http://192.168.1.117:9000/'

let localApi = 'https://www.mimoprint.com/'



let env = process.env.NODE_ENV, baseURL = env == 'production' ?'/' :localApi

var instance = axios.create({
    baseURL: baseURL,
    withCredentials: true,
})

//
let AUTH_TOKEN = (function(){
    return localStorage.getItem("token")
})()

AUTH_TOKEN && (instance.defaults.headers.common["Authorization"] = AUTH_TOKEN)

//请求拦截
instance.interceptors.request.use(function(config){

    config.headers.need = true

    config.headers.Authorization = localStorage.getItem("token")
    
    return config
},function(err){
    return Promise.reject(err)
})

//接收拦截
instance.interceptors.response.use(function(res){
    if(res.headers.token){
        localStorage.setItem('token',res.headers.token)
    }
    
    //未登录拦截跳转登录页
    if(res.status === 201 && res.data.code === 996 && router.currentRoute.path !== "/upgrade" && res.config.url !== '/api/login/check' ){
        router.replace({
            path: '/upgrade',
            query: {
                'callbackUrl': router.currentRoute.fullPath
            }
        })
    }

    return res
},function(err){
    return Promise.reject(err)
})

export default instance